// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.toggle-circle {
  background: #fff;
  border-radius: 50%;
  position: absolute;
  transition: transform 0.3s;
}


/* Container */
.toggle-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* Labels */
.toggle-label {
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
  width: 41%;
}

.toggle-label.right {
  text-align: end;
  width: 35%;
}

Active / Inactive states
.active-label {
  color: #212529;
  opacity: 1;
}

.inactive-label {
  color: #6c757d;
  opacity: 0.5;
}

/* Switch track */
 .toggle-switch {
  position: relative;
  border-radius: 50px;
  background-color: #dee2e6;
  cursor: pointer;
  transition: background-color 0.3s ease;
  flex-shrink: 0;
} 

 .toggle-switch.active {
  background-color: #28a745;
}

 .toggle-switch.inactive {
  background-color: #ed0d20;
}

.toggle-switch.disabled {
  opacity: 0.5;
  cursor: not-allowed;
} 

/* Circle  */
.toggle-circle {
  position: absolute;
  left: 2px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/components/toggle-switch/toggle-switch.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;;AAGA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,iBAAiB;CAChB;EACC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;CAEC;EACC,yBAAyB;AAC3B;;CAEC;EACC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,wCAAwC;AAC1C","sourcesContent":["\n.toggle-circle {\n  background: #fff;\n  border-radius: 50%;\n  position: absolute;\n  transition: transform 0.3s;\n}\n\n\n/* Container */\n.toggle-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n/* Labels */\n.toggle-label {\n  font-weight: 600;\n  cursor: pointer;\n  transition: 0.2s ease;\n  width: 41%;\n}\n\n.toggle-label.right {\n  text-align: end;\n  width: 35%;\n}\n\nActive / Inactive states\n.active-label {\n  color: #212529;\n  opacity: 1;\n}\n\n.inactive-label {\n  color: #6c757d;\n  opacity: 0.5;\n}\n\n/* Switch track */\n .toggle-switch {\n  position: relative;\n  border-radius: 50px;\n  background-color: #dee2e6;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  flex-shrink: 0;\n} \n\n .toggle-switch.active {\n  background-color: #28a745;\n}\n\n .toggle-switch.inactive {\n  background-color: #ed0d20;\n}\n\n.toggle-switch.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n} \n\n/* Circle  */\n.toggle-circle {\n  position: absolute;\n  left: 2px;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
